<template>
  <AuthFailure :is-logout-redirect="true">
    <template #textSlot>
      <h2 style='max-width:750px'>У вас нет доступа к данному разделу или сайту.<br />Пожалуйста, авторизуйтесь под другой учетной записью</h2>
    </template>
  </AuthFailure>
</template>

<script>
import AuthFailure from '@/components/view_blocks/Auth_failure/AuthFailure.vue';

export default {
  components: {
    AuthFailure
  },
};
</script>

<style scoped>

</style>
